import { MenuItem as MaterialItem, Menu } from "@mui/material";
import { OLButton } from "OLButton";
import { ReactComponent as AlertTriangleIcon } from "components/Icons/alert-triangle.svg";
import { ReactComponent as DotsVerticalIcon } from "components/Icons/dots-vertical.svg";
import { Tooltip } from "components/Tooltips/Tooltip";
import { useContextMenu } from "hooks/contextMenu";
import { useMessage } from "hooks/intl";
import { useStyles } from "./Menu";

interface Props {
  idx: number;
  setActiveRule: (idx: number) => void;
  isSelected: boolean;
  hasError: boolean;
  onDelete: () => void;
  onDuplicate: () => void;
  isDisabled: {
    delete: boolean;
    duplicate: boolean;
  };
  name?: string;
  isEditMode: boolean;
  "data-test-id": string;
}

export const MenuItem = ({
  idx,
  setActiveRule,
  isSelected,
  hasError,
  isDisabled,
  onDelete,
  onDuplicate,
  name,
  isEditMode,
  "data-test-id": dataTestId,
}: Props) => {
  const { message } = useMessage();
  const classes = useStyles({ isSelected });

  const contextMenu = useContextMenu();

  const isNameProvided = name && name.trim().length > 0;
  const maxNameLength = 12;
  const isNameToLong = isNameProvided && name.length > maxNameLength;

  return (
    <>
      <OLButton
        id={`rule-${idx}`}
        key={idx}
        onClick={() => setActiveRule(idx)}
        variant={isSelected ? "contained" : "outlined"}
        sx={{
          borderColor: "transparent",
        }}
        className={classes.btn}
        startIcon={
          hasError && <AlertTriangleIcon className={classes.warnIcon} />
        }
        size="small"
        data-test-id={dataTestId}
      >
        <span>
          <Tooltip text={isNameToLong ? name : ""}>
            <span>
              {isNameProvided
                ? isNameToLong
                  ? `${name.substring(0, maxNameLength)}...`
                  : name
                : message({ id: "ruleNumber" }, { number: idx + 1 })}
            </span>
          </Tooltip>
        </span>

        <div className={classes.contextMenu}>
          <DotsVerticalIcon
            fill="white"
            onClick={(e) => {
              contextMenu.handleMenuOpen(e);
            }}
          />
        </div>
      </OLButton>

      <Menu
        classes={{ paper: classes.ruleMenu }}
        anchorEl={contextMenu.anchor}
        anchorOrigin={{
          horizontal: "center",
          vertical: "bottom",
        }}
        onClose={contextMenu.handleMenuClose}
        open={contextMenu.isMenuOpen}
        transformOrigin={{
          horizontal: "left",
          vertical: "top",
        }}
      >
        <MaterialItem
          className={classes.ruleMenuItem}
          disabled={isDisabled.duplicate}
          onClick={() => {
            onDuplicate();
            contextMenu.handleMenuClose();
          }}
        >
          {message({ id: "duplicateRule" })}{" "}
        </MaterialItem>
        <MaterialItem
          className={classes.ruleMenuItem}
          disabled={isDisabled.delete}
          onClick={() => {
            onDelete();
            contextMenu.handleMenuClose();
          }}
        >
          {message({ id: "deleteRule" })}{" "}
        </MaterialItem>
      </Menu>
    </>
  );
};
